// import React, { useState } from "react";
// import "./Foodratings.css";

// const Ratings = () => {
//     const [activeTab, setActiveTab] = useState("reviews");
//     const [selectedReviews, setSelectedReviews] = useState([]);
//     const isMobile = window.innerWidth <= 768;
    
//     // Sample reviews data
//     const reviews = [
//         {
//             id: 1,
//             orderId: "Order-99121",
//             date: "Oct 12, 2023",
//             product: "Gopro Hero 7 - Single",
//             rating: 2,
//             comment: "I'm disappointed. The video quality isn't as sharp as expected, especially in low light.",
//             user: "Wade Warren",
//             status: "pending",
//             productImage: "📷"
//         },
//         {
//             id: 2,
//             orderId: "Order-99122",
//             date: "Oct 13, 2023",
//             product: "Canon EOS R5",
//             rating: 5,
//             comment: "Absolutely amazing! The image quality exceeded all my expectations. Best purchase ever!",
//             user: "Emma Wilson",
//             status: "published",
//             productImage: "📸"
//         },
//         {
//             id: 3,
//             orderId: "Order-99123",
//             date: "Oct 14, 2023",
//             product: "Sony A7 III",
//             rating: 4,
//             comment: "Great camera overall. The autofocus is fantastic, battery life could be better.",
//             user: "Michael Chen",
//             status: "published",
//             productImage: "🎥"
//         },
//         {
//             id: 4,
//             orderId: "Order-99124",
//             date: "Oct 15, 2023",
//             product: "Nikon Z6 II",
//             rating: 3,
//             comment: "Good camera but the menu system is complicated. Video quality is decent.",
//             user: "Sarah Johnson",
//             status: "archived",
//             productImage: "📹"
//         },
//         {
//             id: 5,
//             orderId: "Order-99125",
//             date: "Oct 16, 2023",
//             product: "Fujifilm X-T4",
//             rating: 5,
//             comment: "Love the film simulations! Perfect for street photography.",
//             user: "David Kim",
//             status: "pending",
//             productImage: "🎞️"
//         },
//         {
//             id: 6,
//             orderId: "Order-99126",
//             date: "Oct 17, 2023",
//             product: "Panasonic Lumix S5",
//             rating: 1,
//             comment: "Multiple issues with the unit. Returning it. Very disappointed.",
//             user: "Robert Garcia",
//             status: "pending",
//             productImage: "📽️"
//         }
//     ];

//     // Sample responses data
//     const responses = [
//         {
//             id: 1,
//             reviewId: "Review-1001",
//             date: "Oct 15, 2023",
//             customerName: "Wade Warren",
//             reviewText: "I'm disappointed. The video quality isn't as sharp as expected.",
//             responseText: "Thank you for your feedback. We're sorry to hear about your experience...",
//             responseStatus: "Published",
//             rating: 2
//         },
//         {
//             id: 2,
//             reviewId: "Review-1002",
//             date: "Oct 16, 2023",
//             customerName: "Emma Wilson",
//             reviewText: "Absolutely amazing! The image quality exceeded all my expectations.",
//             responseText: "We're thrilled to hear you're enjoying your purchase! Thank you!",
//             responseStatus: "Published",
//             rating: 5
//         },
//         {
//             id: 3,
//             reviewId: "Review-1003",
//             date: "Oct 17, 2023",
//             customerName: "Michael Chen",
//             reviewText: "Great camera overall. The autofocus is fantastic.",
//             responseText: "",
//             responseStatus: "Pending",
//             rating: 4
//         },
//         {
//             id: 4,
//             reviewId: "Review-1004",
//             date: "Oct 18, 2023",
//             customerName: "Sarah Johnson",
//             reviewText: "Good camera but the menu system is complicated.",
//             responseText: "We appreciate your feedback. Our team is working on improving the UI.",
//             responseStatus: "Draft",
//             rating: 3
//         }
//     ];

//     const handleSelectReview = (id) => {
//         if (selectedReviews.includes(id)) {
//             setSelectedReviews(selectedReviews.filter(reviewId => reviewId !== id));
//         } else {
//             setSelectedReviews([...selectedReviews, id]);
//         }
//     };

//     const handleSelectAll = () => {
//         if (selectedReviews.length === reviews.length) {
//             setSelectedReviews([]);
//         } else {
//             setSelectedReviews(reviews.map(review => review.id));
//         }
//     };

//     const getStatusColor = (status) => {
//         switch(status) {
//             case 'published': return '#10b981';
//             case 'pending': return '#f59e0b';
//             case 'archived': return '#6b7280';
//             default: return '#6b7280';
//         }
//     };

//     return (
//         <div className="ratings-container">
//             {/* Header */}
//             <div className="ratings-header">
//                 <h2 style={{ 
//                     color: "#333",
//                     marginBottom: "10px",
//                     fontSize: isMobile ? "24px" : "28px"
//                 }}>
//                     Customer Reviews & Ratings
//                 </h2>
//                 <p style={{ 
//                     color: "#666",
//                     marginBottom: "30px",
//                     fontSize: isMobile ? "14px" : "16px"
//                 }}>
//                     Centralized hub for all customer feedback and response management
//                 </p>
//             </div>

//             {/* Tabs */}
//             <div className="ratings-tabs">
//                 <button 
//                     className={`tab ${activeTab === 'reviews' ? 'active' : ''}`}
//                     onClick={() => setActiveTab('reviews')}
//                     style={{
//                         flex: 1,
//                         padding: "15px 20px",
//                         border: "none",
//                         background: activeTab === 'reviews' ? "#b15cd6" : "#f5f5f5",
//                         color: activeTab === 'reviews' ? "white" : "#333",
//                         fontWeight: "bold",
//                         cursor: "pointer",
//                         fontSize: isMobile ? "14px" : "16px",
//                         borderTopLeftRadius: "8px",
//                         borderBottomLeftRadius: "8px"
//                     }}
//                 >
//                     Reviews ({reviews.length})
//                 </button>
//                 <button 
//                     className={`tab ${activeTab === 'responses' ? 'active' : ''}`}
//                     onClick={() => setActiveTab('responses')}
//                     style={{
//                         flex: 1,
//                         padding: "15px 20px",
//                         border: "none",
//                         background: activeTab === 'responses' ? "#b15cd6" : "#f5f5f5",
//                         color: activeTab === 'responses' ? "white" : "#333",
//                         fontWeight: "bold",
//                         cursor: "pointer",
//                         fontSize: isMobile ? "14px" : "16px",
//                         borderTopRightRadius: "8px",
//                         borderBottomRightRadius: "8px"
//                     }}
//                 >
//                     Responses ({responses.length})
//                 </button>
//             </div>

//             {/* Content based on active tab */}
//             {activeTab === 'reviews' ? (
//                 <>
//                     {/* Filters Bar */}
//                     <div style={{
//                         display: "flex",
//                         flexWrap: "wrap",
//                         gap: "10px",
//                         margin: "30px 0",
//                         alignItems: "center",
//                         padding: "15px",
//                         backgroundColor: "#f8f9fa",
//                         borderRadius: "8px"
//                     }}>
//                         <div style={{
//                             display: "flex",
//                             flexWrap: "wrap",
//                             gap: "10px",
//                             flex: 1
//                         }}>
//                             <select style={{
//                                 padding: "10px 15px",
//                                 border: "1px solid #ddd",
//                                 borderRadius: "6px",
//                                 fontSize: "14px",
//                                 minWidth: "150px"
//                             }}>
//                                 <option>All Ratings</option>
//                                 <option>5 Stars</option>
//                                 <option>4 Stars</option>
//                                 <option>3 Stars</option>
//                                 <option>2 Stars</option>
//                                 <option>1 Star</option>
//                             </select>
                            
//                             <select style={{
//                                 padding: "10px 15px",
//                                 border: "1px solid #ddd",
//                                 borderRadius: "6px",
//                                 fontSize: "14px",
//                                 minWidth: "150px"
//                             }}>
//                                 <option>All Status</option>
//                                 <option>Published</option>
//                                 <option>Pending</option>
//                                 <option>Archived</option>
//                             </select>
                            
//                             <input 
//                                 type="text"
//                                 placeholder="Search reviews..."
//                                 style={{
//                                     padding: "10px 15px",
//                                     border: "1px solid #ddd",
//                                     borderRadius: "6px",
//                                     fontSize: "14px",
//                                     flex: 1,
//                                     minWidth: "200px"
//                                 }}
//                             />
//                         </div>
                        
//                         <button style={{
//                             padding: "10px 20px",
//                             backgroundColor: "#4CAF50",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "6px",
//                             fontWeight: "bold",
//                             cursor: "pointer",
//                             fontSize: "14px"
//                         }}>
//                             + Create New
//                         </button>
//                     </div>

//                     {/* AI Summary */}
//                     <div style={{
//                         backgroundColor: "#e8f4ff",
//                         padding: "20px",
//                         borderRadius: "8px",
//                         marginBottom: "30px",
//                         borderLeft: "4px solid #2196F3"
//                     }}>
//                         <h4 style={{ 
//                             color: "#1565C0",
//                             marginBottom: "10px",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "10px"
//                         }}>
//                             <span>🤖</span> AI Review Analysis
//                         </h4>
//                         <p style={{ 
//                             color: "#333",
//                             fontSize: "14px",
//                             lineHeight: "1.6"
//                         }}>
//                             <strong>Customers are generally satisfied</strong> · 
//                             68% positive sentiment · 45% mention product quality · 
//                             32% discuss pricing · 15% need response
//                         </p>
//                     </div>

//                     {/* Reviews Grid */}
//                     <div style={{
//                         display: "grid",
//                         gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
//                         gap: "20px",
//                         marginBottom: "30px"
//                     }}>
//                         {reviews.map((review) => (
//                             <div key={review.id} style={{
//                                 backgroundColor: "white",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "8px",
//                                 padding: "20px",
//                                 boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                                 transition: "all 0.3s ease"
//                             }}>
//                                 <div style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     marginBottom: "15px"
//                                 }}>
//                                     <div style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "10px"
//                                     }}>
//                                         <input 
//                                             type="checkbox" 
//                                             checked={selectedReviews.includes(review.id)}
//                                             onChange={() => handleSelectReview(review.id)}
//                                             style={{
//                                                 width: "18px",
//                                                 height: "18px",
//                                                 cursor: "pointer"
//                                             }}
//                                         />
//                                         <span style={{
//                                             fontSize: "13px",
//                                             fontWeight: "600",
//                                             color: "#10b981",
//                                             backgroundColor: "#d1fae5",
//                                             padding: "4px 12px",
//                                             borderRadius: "20px"
//                                         }}>
//                                             {review.orderId}
//                                         </span>
//                                     </div>
//                                     <span style={{
//                                         fontSize: "12px",
//                                         fontWeight: "600",
//                                         color: "white",
//                                         backgroundColor: getStatusColor(review.status),
//                                         padding: "4px 12px",
//                                         borderRadius: "20px"
//                                     }}>
//                                         {review.status.charAt(0).toUpperCase() + review.status.slice(1)}
//                                     </span>
//                                 </div>
                                
//                                 <div style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     marginBottom: "15px"
//                                 }}>
//                                     <div style={{
//                                         color: "#fbbf24",
//                                         fontSize: "20px",
//                                         letterSpacing: "2px"
//                                     }}>
//                                         {"★".repeat(review.rating)}
//                                         {"☆".repeat(5 - review.rating)}
//                                     </div>
//                                     <span style={{
//                                         fontSize: "13px",
//                                         color: "#666"
//                                     }}>
//                                         {review.date}
//                                     </span>
//                                 </div>
                                
//                                 <h4 style={{
//                                     color: "#3b82f6",
//                                     marginBottom: "10px",
//                                     fontSize: "16px"
//                                 }}>
//                                     {review.product}
//                                 </h4>
                                
//                                 <p style={{
//                                     color: "#333",
//                                     lineHeight: "1.6",
//                                     marginBottom: "15px",
//                                     fontSize: "14px"
//                                 }}>
//                                     {review.comment}
//                                 </p>
                                
//                                 <div style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "10px",
//                                     marginBottom: "20px"
//                                 }}>
//                                     <div style={{
//                                         width: "36px",
//                                         height: "36px",
//                                         backgroundColor: "#b15cd6",
//                                         borderRadius: "50%",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         color: "white",
//                                         fontWeight: "600",
//                                         fontSize: "14px"
//                                     }}>
//                                         {review.user.charAt(0)}
//                                     </div>
//                                     <span style={{
//                                         fontSize: "14px",
//                                         color: "#333"
//                                     }}>
//                                         {review.user}
//                                     </span>
//                                 </div>
                                
//                                 <div style={{
//                                     display: "flex",
//                                     gap: "10px"
//                                 }}>
//                                     <button style={{
//                                         flex: 1,
//                                         padding: "10px",
//                                         backgroundColor: "#4CAF50",
//                                         color: "white",
//                                         border: "none",
//                                         borderRadius: "6px",
//                                         fontWeight: "600",
//                                         cursor: "pointer",
//                                         fontSize: "14px"
//                                     }}>
//                                         {review.status === 'pending' ? 'Publish & Respond' : 'View'}
//                                     </button>
//                                     <button style={{
//                                         flex: 1,
//                                         padding: "10px",
//                                         backgroundColor: "white",
//                                         border: "1px solid #ddd",
//                                         color: "#666",
//                                         borderRadius: "6px",
//                                         fontWeight: "600",
//                                         cursor: "pointer",
//                                         fontSize: "14px"
//                                     }}>
//                                         Archive
//                                     </button>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Bulk Actions */}
//                     {selectedReviews.length > 0 && (
//                         <div style={{
//                             position: "sticky",
//                             bottom: "20px",
//                             backgroundColor: "#1e293b",
//                             color: "white",
//                             padding: "15px 20px",
//                             borderRadius: "8px",
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             marginTop: "20px",
//                             boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
//                         }}>
//                             <div style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "15px"
//                             }}>
//                                 <span>{selectedReviews.length} reviews selected</span>
//                                 <button 
//                                     onClick={handleSelectAll}
//                                     style={{
//                                         background: "none",
//                                         border: "none",
//                                         color: "#94a3b8",
//                                         cursor: "pointer",
//                                         fontSize: "14px"
//                                     }}
//                                 >
//                                     {selectedReviews.length === reviews.length ? 'Deselect All' : 'Select All'}
//                                 </button>
//                             </div>
//                             <div style={{
//                                 display: "flex",
//                                 gap: "10px"
//                             }}>
//                                 <button style={{
//                                     padding: "8px 16px",
//                                     backgroundColor: "rgba(255,255,255,0.1)",
//                                     color: "white",
//                                     border: "1px solid rgba(255,255,255,0.2)",
//                                     borderRadius: "4px",
//                                     cursor: "pointer",
//                                     fontSize: "14px"
//                                 }}>
//                                     Publish Selected
//                                 </button>
//                                 <button style={{
//                                     padding: "8px 16px",
//                                     backgroundColor: "rgba(255,255,255,0.1)",
//                                     color: "white",
//                                     border: "1px solid rgba(255,255,255,0.2)",
//                                     borderRadius: "4px",
//                                     cursor: "pointer",
//                                     fontSize: "14px"
//                                 }}>
//                                     Archive Selected
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             ) : (
//                 <>
//                     {/* Responses Tab Content */}
//                     <div style={{
//                         backgroundColor: "white",
//                         borderRadius: "8px",
//                         padding: "20px",
//                         marginTop: "30px",
//                         border: "1px solid #e0e0e0"
//                     }}>
//                         <h3 style={{ 
//                             color: "#333",
//                             marginBottom: "20px",
//                             fontSize: isMobile ? "20px" : "24px"
//                         }}>
//                             Response Management
//                         </h3>
                        
//                         <div style={{
//                             display: "grid",
//                             gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
//                             gap: "20px"
//                         }}>
//                             {responses.map((response) => (
//                                 <div key={response.id} style={{
//                                     backgroundColor: "white",
//                                     border: "1px solid #e0e0e0",
//                                     borderRadius: "8px",
//                                     padding: "20px",
//                                     boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
//                                 }}>
//                                     <div style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         alignItems: "center",
//                                         marginBottom: "15px"
//                                     }}>
//                                         <div style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             gap: "10px"
//                                         }}>
//                                             <span style={{
//                                                 fontSize: "13px",
//                                                 fontWeight: "600",
//                                                 color: "#1e40af",
//                                                 backgroundColor: "#dbeafe",
//                                                 padding: "4px 12px",
//                                                 borderRadius: "20px"
//                                             }}>
//                                                 {response.reviewId}
//                                             </span>
//                                             <div style={{
//                                                 color: "#fbbf24",
//                                                 fontSize: "16px"
//                                             }}>
//                                                 {"★".repeat(response.rating)}
//                                             </div>
//                                         </div>
//                                         <span style={{
//                                             fontSize: "12px",
//                                             fontWeight: "600",
//                                             color: response.responseStatus === 'Published' ? "white" : "#333",
//                                             backgroundColor: response.responseStatus === 'Published' ? "#10b981" : 
//                                                           response.responseStatus === 'Pending' ? "#fef3c7" : "#e5e7eb",
//                                             padding: "4px 12px",
//                                             borderRadius: "20px"
//                                         }}>
//                                             {response.responseStatus}
//                                         </span>
//                                     </div>
                                    
//                                     <div style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "10px",
//                                         marginBottom: "15px"
//                                     }}>
//                                         <div style={{
//                                             width: "32px",
//                                             height: "32px",
//                                             backgroundColor: "#3b82f6",
//                                             borderRadius: "50%",
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             color: "white",
//                                             fontWeight: "600",
//                                             fontSize: "13px"
//                                         }}>
//                                             {response.customerName.charAt(0)}
//                                         </div>
//                                         <div>
//                                             <div style={{
//                                                 fontWeight: "600",
//                                                 color: "#333",
//                                                 fontSize: "14px"
//                                             }}>
//                                                 {response.customerName}
//                                             </div>
//                                             <div style={{
//                                                 fontSize: "12px",
//                                                 color: "#666"
//                                             }}>
//                                                 {response.date}
//                                             </div>
//                                         </div>
//                                     </div>
                                    
//                                     <div style={{
//                                         backgroundColor: "#f8fafc",
//                                         padding: "15px",
//                                         borderRadius: "6px",
//                                         marginBottom: "15px",
//                                         borderLeft: "4px solid #e2e8f0"
//                                     }}>
//                                         <div style={{
//                                             fontWeight: "600",
//                                             color: "#333",
//                                             marginBottom: "8px",
//                                             fontSize: "14px"
//                                         }}>
//                                             Customer Review:
//                                         </div>
//                                         <p style={{
//                                             color: "#555",
//                                             fontSize: "13px",
//                                             lineHeight: "1.5"
//                                         }}>
//                                             {response.reviewText}
//                                         </p>
//                                     </div>
                                    
//                                     {response.responseText && (
//                                         <div style={{
//                                             backgroundColor: "#f0f9ff",
//                                             padding: "15px",
//                                             borderRadius: "6px",
//                                             marginBottom: "20px",
//                                             borderLeft: "4px solid #3b82f6"
//                                         }}>
//                                             <div style={{
//                                                 fontWeight: "600",
//                                                 color: "#333",
//                                                 marginBottom: "8px",
//                                                 fontSize: "14px"
//                                             }}>
//                                                 Your Response:
//                                             </div>
//                                             <p style={{
//                                                 color: "#555",
//                                                 fontSize: "13px",
//                                                 lineHeight: "1.5"
//                                             }}>
//                                                 {response.responseText}
//                                             </p>
//                                         </div>
//                                     )}
                                    
//                                     <div style={{
//                                         display: "flex",
//                                         gap: "10px"
//                                     }}>
//                                         {response.responseStatus === 'Pending' ? (
//                                             <>
//                                                 <button style={{
//                                                     flex: 1,
//                                                     padding: "10px",
//                                                     backgroundColor: "#4CAF50",
//                                                     color: "white",
//                                                     border: "none",
//                                                     borderRadius: "6px",
//                                                     fontWeight: "600",
//                                                     cursor: "pointer",
//                                                     fontSize: "14px"
//                                                 }}>
//                                                     Write Response
//                                                 </button>
//                                                 <button style={{
//                                                     flex: 1,
//                                                     padding: "10px",
//                                                     backgroundColor: "white",
//                                                     border: "1px solid #ddd",
//                                                     color: "#666",
//                                                     borderRadius: "6px",
//                                                     fontWeight: "600",
//                                                     cursor: "pointer",
//                                                     fontSize: "14px"
//                                                 }}>
//                                                     Use Template
//                                                 </button>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <button style={{
//                                                     flex: 1,
//                                                     padding: "10px",
//                                                     backgroundColor: "#3b82f6",
//                                                     color: "white",
//                                                     border: "none",
//                                                     borderRadius: "6px",
//                                                     fontWeight: "600",
//                                                     cursor: "pointer",
//                                                     fontSize: "14px"
//                                                 }}>
//                                                     Edit Response
//                                                 </button>
//                                                 <button style={{
//                                                     flex: 1,
//                                                     padding: "10px",
//                                                     backgroundColor: "white",
//                                                     border: "1px solid #ddd",
//                                                     color: "#666",
//                                                     borderRadius: "6px",
//                                                     fontWeight: "600",
//                                                     cursor: "pointer",
//                                                     fontSize: "14px"
//                                                 }}>
//                                                     View Details
//                                                 </button>
//                                             </>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
                        
//                         {/* Response Stats */}
//                         <div style={{
//                             backgroundColor: "#f0f7ff",
//                             padding: "20px",
//                             borderRadius: "8px",
//                             marginTop: "30px",
//                             borderLeft: "4px solid #2196F3"
//                         }}>
//                             <h4 style={{ 
//                                 color: "#1565C0",
//                                 marginBottom: "15px",
//                                 fontSize: "18px"
//                             }}>
//                                 📈 Response Performance
//                             </h4>
//                             <div style={{
//                                 display: "grid",
//                                 gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
//                                 gap: "15px"
//                             }}>
//                                 <div style={{
//                                     textAlign: "center",
//                                     padding: "15px",
//                                     backgroundColor: "white",
//                                     borderRadius: "6px",
//                                     border: "1px solid #e0e0e0"
//                                 }}>
//                                     <div style={{
//                                         fontSize: "24px",
//                                         fontWeight: "700",
//                                         color: "#3b82f6",
//                                         marginBottom: "5px"
//                                     }}>
//                                         78%
//                                     </div>
//                                     <div style={{
//                                         color: "#64748b",
//                                         fontSize: "13px"
//                                     }}>
//                                         Response Rate
//                                     </div>
//                                 </div>
//                                 <div style={{
//                                     textAlign: "center",
//                                     padding: "15px",
//                                     backgroundColor: "white",
//                                     borderRadius: "6px",
//                                     border: "1px solid #e0e0e0"
//                                 }}>
//                                     <div style={{
//                                         fontSize: "24px",
//                                         fontWeight: "700",
//                                         color: "#10b981",
//                                         marginBottom: "5px"
//                                     }}>
//                                         4.2h
//                                     </div>
//                                     <div style={{
//                                         color: "#64748b",
//                                         fontSize: "13px"
//                                     }}>
//                                         Avg. Response Time
//                                     </div>
//                                 </div>
//                                 <div style={{
//                                     textAlign: "center",
//                                     padding: "15px",
//                                     backgroundColor: "white",
//                                     borderRadius: "6px",
//                                     border: "1px solid #e0e0e0"
//                                 }}>
//                                     <div style={{
//                                         fontSize: "24px",
//                                         fontWeight: "700",
//                                         color: "#f59e0b",
//                                         marginBottom: "5px"
//                                     }}>
//                                         92%
//                                     </div>
//                                     <div style={{
//                                         color: "#64748b",
//                                         fontSize: "13px"
//                                     }}>
//                                         Satisfaction Score
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </>
//             )}

//             {/* Pagination */}
//             <div style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: "10px",
//                 marginTop: "30px",
//                 padding: "20px 0"
//             }}>
//                 <button style={{
//                     padding: "8px 16px",
//                     border: "1px solid #ddd",
//                     backgroundColor: "white",
//                     borderRadius: "4px",
//                     cursor: "pointer",
//                     fontSize: "14px"
//                 }}>
//                     ← Previous
//                 </button>
//                 <div style={{
//                     display: "flex",
//                     gap: "5px"
//                 }}>
//                     {[1, 2, 3, '...', 10].map((page, index) => (
//                         <button
//                             key={index}
//                             style={{
//                                 width: "40px",
//                                 height: "40px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 borderRadius: "4px",
//                                 border: page === 1 ? "1px solid #b15cd6" : "1px solid #ddd",
//                                 backgroundColor: page === 1 ? "#b15cd6" : "white",
//                                 color: page === 1 ? "white" : "#333",
//                                 cursor: "pointer",
//                                 fontSize: "14px"
//                             }}
//                         >
//                             {page}
//                         </button>
//                     ))}
//                 </div>
//                 <button style={{
//                     padding: "8px 16px",
//                     border: "1px solid #ddd",
//                     backgroundColor: "white",
//                     borderRadius: "4px",
//                     cursor: "pointer",
//                     fontSize: "14px"
//                 }}>
//                     Next →
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default Ratings;


import React, { useState } from "react";

const Ratings = () => {
    const [selectedReviews, setSelectedReviews] = useState([]);
    const isMobile = window.innerWidth <= 768;
    
    // Sample reviews data
    const reviews = [
        {
            id: 1,
            orderId: "Order-99121",
            date: "Oct 12, 2023",
            product: "Gopro Hero 7 - Single",
            rating: 2,
            comment: "I'm disappointed. The video quality isn't as sharp as expected, especially in low light.",
            user: "Wade Warren",
            status: "pending",
            productImage: "📷"
        },
        {
            id: 2,
            orderId: "Order-99122",
            date: "Oct 13, 2023",
            product: "Canon EOS R5",
            rating: 5,
            comment: "Absolutely amazing! The image quality exceeded all my expectations. Best purchase ever!",
            user: "Emma Wilson",
            status: "published",
            productImage: "📸"
        },
        {
            id: 3,
            orderId: "Order-99123",
            date: "Oct 14, 2023",
            product: "Sony A7 III",
            rating: 4,
            comment: "Great camera overall. The autofocus is fantastic, battery life could be better.",
            user: "Michael Chen",
            status: "published",
            productImage: "🎥"
        },
        {
            id: 4,
            orderId: "Order-99124",
            date: "Oct 15, 2023",
            product: "Nikon Z6 II",
            rating: 3,
            comment: "Good camera but the menu system is complicated. Video quality is decent.",
            user: "Sarah Johnson",
            status: "archived",
            productImage: "📹"
        },
        {
            id: 5,
            orderId: "Order-99125",
            date: "Oct 16, 2023",
            product: "Fujifilm X-T4",
            rating: 5,
            comment: "Love the film simulations! Perfect for street photography.",
            user: "David Kim",
            status: "pending",
            productImage: "🎞️"
        },
        {
            id: 6,
            orderId: "Order-99126",
            date: "Oct 17, 2023",
            product: "Panasonic Lumix S5",
            rating: 1,
            comment: "Multiple issues with the unit. Returning it. Very disappointed.",
            user: "Robert Garcia",
            status: "pending",
            productImage: "📽️"
        }
    ];

    const handleSelectReview = (id) => {
        if (selectedReviews.includes(id)) {
            setSelectedReviews(selectedReviews.filter(reviewId => reviewId !== id));
        } else {
            setSelectedReviews([...selectedReviews, id]);
        }
    };

    const handleSelectAll = () => {
        if (selectedReviews.length === reviews.length) {
            setSelectedReviews([]);
        } else {
            setSelectedReviews(reviews.map(review => review.id));
        }
    };

    const getStatusColor = (status) => {
        switch(status) {
            case 'published': return '#10b981';
            case 'pending': return '#f59e0b';
            case 'archived': return '#6b7280';
            default: return '#6b7280';
        }
    };

    return (
        <div>
            {/* Header */}
            

            {/* Filters Bar */}
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                margin: "0 0 20px 0",
                alignItems: "center",
                padding: "15px",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px"
            }}>
                <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    flex: 1,
                    justifyContent:window.innerWidth<500 ? "space-around" : " "
                }}>
                    <select style={{
                        padding: "10px 15px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        fontSize: "14px",
                        minWidth: "150px"
                    }}>
                        <option>All Ratings</option>
                        <option>5 Stars</option>
                        <option>4 Stars</option>
                        <option>3 Stars</option>
                        <option>2 Stars</option>
                        <option>1 Star</option>
                    </select>
                    
                    <select style={{
                        padding: "10px 15px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        fontSize: "14px",
                        minWidth: "150px"
                    }}>
                        <option>All Status</option>
                        <option>Published</option>
                        <option>Pending</option>
                        <option>Archived</option>
                    </select>
                    
                    <input 
                        type="text"
                        placeholder="Search reviews..."
                        style={{
                            padding: "10px 15px",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            fontSize: "14px",
                            flex: 1,
                            minWidth: "200px"
                        }}
                    />
                </div>
                
                <button style={{
                    padding: "10px 20px",
                    backgroundColor: "#b15cd6",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "14px"
                }}>
                    + Request Review
                </button>
            </div>

            

            {/* Reviews Grid */}
            <div style={{
                display: "grid",
                gridTemplateColumns: window.innerWidth<600 ? "1fr" : window.innerWidth<769 ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
                gap: "15px",
                marginBottom: "20px"
            }}>
                {reviews.map((review) => (
                    <div key={review.id} style={{
                        backgroundColor: "white",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: "15px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        transition: "all 0.3s ease"
                    }}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px"
                        }}>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}>
                                <input 
                                    type="checkbox" 
                                    checked={selectedReviews.includes(review.id)}
                                    onChange={() => handleSelectReview(review.id)}
                                    style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer"
                                    }}
                                />
                                <span style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#10b981",
                                    backgroundColor: "#d1fae5",
                                    padding: "4px 10px",
                                    borderRadius: "20px"
                                }}>
                                    {review.orderId}
                                </span>
                            </div>
                            <span style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: getStatusColor(review.status),
                                padding: "4px 10px",
                                borderRadius: "20px"
                            }}>
                                {review.status.charAt(0).toUpperCase() + review.status.slice(1)}
                            </span>
                        </div>
                        
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px"
                        }}>
                            <div style={{
                                color: "#fbbf24",
                                fontSize: "18px",
                                letterSpacing: "1px"
                            }}>
                                {"★".repeat(review.rating)}
                                {"☆".repeat(5 - review.rating)}
                            </div>
                            <span style={{
                                fontSize: "12px",
                                color: "#666"
                            }}>
                                {review.date}
                            </span>
                        </div>
                        
                        <h4 style={{
                            color: "#3b82f6",
                            marginBottom: "8px",
                            fontSize: "15px"
                        }}>
                            {review.product}
                        </h4>
                        
                        <p style={{
                            color: "#333",
                            lineHeight: "1.5",
                            marginBottom: "12px",
                            fontSize: "13px"
                        }}>
                            {review.comment}
                        </p>
                        
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "15px"
                        }}>
                            <div style={{
                                width: "32px",
                                height: "32px",
                                backgroundColor: "#b15cd6",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontWeight: "600",
                                fontSize: "13px"
                            }}>
                                {review.user.charAt(0)}
                            </div>
                            <span style={{
                                fontSize: "13px",
                                color: "#333"
                            }}>
                                {review.user}
                            </span>
                        </div>
                        
                        <div style={{
                            display: "flex",
                            gap: "10px"
                        }}>
                            <button style={{
                                flex: 1,
                                padding: "8px",
                                backgroundColor: "#4CAF50",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                fontWeight: "600",
                                cursor: "pointer",
                                fontSize: "13px"
                            }}>
                                {review.status === 'pending' ? 'Publish & Respond' : 'View'}
                            </button>
                            <button style={{
                                flex: 1,
                                padding: "8px",
                                backgroundColor: "white",
                                border: "1px solid #ddd",
                                color: "#666",
                                borderRadius: "6px",
                                fontWeight: "600",
                                cursor: "pointer",
                                fontSize: "13px"
                            }}>
                                Archive
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Bulk Actions */}
            {selectedReviews.length > 0 && (
                <div style={{
                    position: "sticky",
                    bottom: "10px",
                    backgroundColor: "#1e293b",
                    color: "white",
                    padding: "12px 15px",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "15px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    zIndex: 10
                }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px"
                    }}>
                        <span style={{ fontSize: "14px" }}>{selectedReviews.length} reviews selected</span>
                        <button 
                            onClick={handleSelectAll}
                            style={{
                                background: "none",
                                border: "none",
                                color: "#94a3b8",
                                cursor: "pointer",
                                fontSize: "13px"
                            }}
                        >
                            {selectedReviews.length === reviews.length ? 'Deselect All' : 'Select All'}
                        </button>
                    </div>
                    <div style={{
                        display: "flex",
                        gap: "10px"
                    }}>
                        <button style={{
                            padding: "6px 12px",
                            backgroundColor: "rgba(255,255,255,0.1)",
                            color: "white",
                            border: "1px solid rgba(255,255,255,0.2)",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "13px"
                        }}>
                            Publish Selected
                        </button>
                        <button style={{
                            padding: "6px 12px",
                            backgroundColor: "rgba(255,255,255,0.1)",
                            color: "white",
                            border: "1px solid rgba(255,255,255,0.2)",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "13px"
                        }}>
                            Archive Selected
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Ratings;